module.exports = __webpack_public_path__ + "img/cx_icon_01.png";